import {TreeViewContainerComponent} from "./tree-view-container.component";
import {TreeViewNodeComponent} from "./tree-view-node.component";
import {FilterBusinessTypes} from "../filter/filter-business-types.component";
import {FilteredTreeViewComponent} from "./filtered-tree-view.component";

export const TREE_COMPONENTS = [
    TreeViewContainerComponent,
    TreeViewNodeComponent,
    FilterBusinessTypes,
    FilteredTreeViewComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/business-categories/tree/index.ts